// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_gc-0";
export var headerCellHover = "_gc-1";
export var readCellContainer = "_gc-2";
export var unreadIndicator = "_gc-3";